import { IconButton } from '@synoptic/ui-kit/button/icon-button.js';
import { CircleSparkIcon } from '@synoptic/ui-kit/icons/react/circle-spark.js';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@synoptic/ui-kit/tooltip/tooltip.js';
import { clsx } from 'clsx';
import {
  summarizePostButton,
  summarizePostButtonCompact,
} from './summarize.css.ts';

export const SummarizePostButton = ({
  isSummaryVisible,
  onClick,
  compact,
}: {
  isSummaryVisible: boolean;
  onClick: () => void;
  compact?: boolean;
}) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <IconButton
        size="xSmall"
        variant="ghost"
        pressed={isSummaryVisible}
        aria-label={isSummaryVisible ? 'Hide summary' : 'Summarize post'}
        className={clsx(
          summarizePostButton,
          compact && summarizePostButtonCompact,
        )}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      >
        <CircleSparkIcon />
      </IconButton>
    </TooltipTrigger>
    <TooltipContent
      side="bottom"
      description={isSummaryVisible ? 'Hide AI summary' : 'Summarize with AI'}
    />
  </Tooltip>
);
